import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';

/* image */
import Pross1 from '../../images/step1.webp'
import Pross2 from '../../images/step2.webp'
import Pross3 from '../../images/step3.webp'
import Pross4 from '../../images/step4.webp'
import Shape from '../../images/work/shape.svg'

const ProcessSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={'What We Do'} subtitle={'How it works'} />
                    </div>
                </div>
                <div className="work_wrapper">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross1} alt="" />
                                    <span className="number">01</span>
                                </div>
                                <div className="text">
                                    <h3>Acquire & Invest</h3>
                                    <p>We identify and purchase high-potential independent pharmacies, then invest capital to fuel their growth and improvement.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross2} alt="" />
                                    <span className="number">02</span>
                                </div>
                                <div className="text">
                                    <h3>Enhance & Grow</h3>
                                    <p>We implement strategies to optimize pharmacy performance and maximize value for our investors and acquired pharmacies.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross3} alt="" />
                                    <span className="number">03</span>
                                </div>
                                <div className="text">
                                    <h3>Support & Innovate</h3>
                                    <p>We provide ongoing operational support and introduce cutting-edge technologies to stay ahead in the market.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="image">
                                    <img src={Pross4} alt="" />
                                    <span className="number">04</span>
                                </div>
                                <div className="text">
                                    <h3>Optimize & Exit</h3>
                                    <p>We develop and execute a clear plan for a profitable exit, typically selling to a larger pharmacy group at a higher valuation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape">
                        <img src={Shape} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;